import { FC } from "react";
import { DatePicker } from "antd";
import { Dayjs } from "dayjs";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Trigger } from "../components";

const { RangePicker } = DatePicker;

const OrdersListFiltersWeb: FC<{ from: Dayjs; to: Dayjs; setDateRange: (range: [Dayjs, Dayjs]) => void }> = ({ from, to, setDateRange }) => {
  return (
    <Trigger>
      <RangePicker
        picker="month"
        value={[from, to]}
        onChange={(dates) => {
          if (!dates?.[0] || !dates?.[1]) return;
          setDateRange([dates[0].startOf("month"), dates[1].endOf("month")]);
        }}
        format="MMM YYYY"
        allowClear={false}
        variant="borderless"
        separator={null}
        suffixIcon={<MdKeyboardArrowDown className="text-icon-default size-4" />}
        className="w-full! p-0!"
        classNames={{ input: "text-font-default! font-bold! text-sm! p-0!" }}
      />
    </Trigger>
  );
};

export default OrdersListFiltersWeb;
